import { fetcher } from "helpers/fetcher";

import {
  TGetJobListingRequirementsReq,
  TGetJobListingRequirementsRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getJobListingCertification = async (
  params?: TGetJobListingRequirementsReq
) => {
  return await fetcher<
    TGetJobListingRequirementsRes,
    TGetJobListingRequirementsReq["data"]
  >(ENDPOINT.CORPORATION.GET_JOB_LISTING_CERTIFICATION, {
    params: params?.data,
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.CORPORATION.GET_JOB_LISTING_CERTIFICATION.version,
      [API_HEADER.CORP_ID]: params?.idCorp,
    },
  });
};

export const queryGetJobListingCertification = async (
  params?: TGetJobListingRequirementsReq
) => {
  return (await getJobListingCertification(params)).data;
};

queryGetJobListingCertification._key = (
  params?: TGetJobListingRequirementsReq,
  key?: number
) => [ENDPOINT.CORPORATION.GET_JOB_LISTING_CERTIFICATION.url, params, key];
